
import { MapLocation } from '@/types/location';

// Game Evening Center Locations
export const gameEveningCenters: MapLocation[] = [
  {
    id: 57001,
    name: "Game Evening - Riyadh (Al Shifa)",
    type: "Game Center",
    devices: 3,
    coordinates: [24.553043377440023, 46.70208124489645],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "17-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
